<template>
<div>
    <div v-if="!customizeLoaded" class="default-graph">
        <img src="../../assets/img/default-graph.png">
    </div>
    <component v-show="customizeLoaded ===true && indexPage!==null" :is="indexPage"></component>
</div>
</template>
<script>
import bilibiliPage  from './index.bilibili.vue'
import defaultPage  from './index.default.vue'
import {httpGet,httpPost} from '@/api/base'
import config from '@/config/config'
import {
    mapGetters,
    mapActions,
    mapState
} from 'vuex'
export default {
    data() {
        return {
            indexPage:null
        };
    },
    components: {
        
    },
    created(){
        this.setComp(this.customizeLoaded)
        
    },
    computed: {
        ...mapState({
            corpCustomizeData:(state)=>{
                return state.customize.corpCustomize
            },
            customizeLoaded:(state)=>{
                return state.customize.customize_loaded
            }
        }),
        ...mapGetters({
            getCustomizeMHome:'getCustomizeMHome',
        }),
    },
    mounted(){
        
    },
    methods:{
        setComp(val){
            if(val && val === true){
               switch (this.getCustomizeMHome) {
                   case 'bilibili':
                        this.indexPage = bilibiliPage
                        break;
                   default:
                       this.indexPage = defaultPage
                       break;
               }
               
           }else{

           }
        }
    },
    watch: {
       customizeLoaded(val){
           this.setComp(val)
           
       }
    },
};
</script>
<style scoped>
.default-graph{
    position: absolute;
    bottom: 0;
    top: 0;
    left: 0;
    right: 0;
    width: 100%;
    background: #fff;
    
}
.default-graph img{
    width: 100%;height: auto;;
}
</style>